// lightbox (Magnific Popup)
jQuery(document).ready(function($) {
  if ($('.js-gallery').length) {
    // český překlad
    $.extend(true, $.magnificPopup.defaults, {
      tClose: 'Zavřít',
      tLoading: 'Nahrávám...',
      gallery: {
        tPrev: 'Předchozí',
        tNext: 'Následující',
        tCounter: '%curr% z %total%'
      },
      image: {
        tError: '<a href="%url%">Obrázek</a> nelze načíst.'
      },
      ajax: {
        tError: '<a href="%url%">Obsah</a> nelze načíst.'
      }
    });

    $('.js-gallery').magnificPopup({
      delegate: 'a',
      type: 'image',
      removalDelay: 300,
      mainClass: 'mfp-fade',
      gallery: {
        enabled: true,
        tCounter: ''
      }
    });
  }
});

jQuery(document).ready(function($) {
  // vlastní select Select2 ( https://select2.org/ )
  if ($('.js-select').length) {
    $('.js-select').select2({
      language: 'cs'
    });
  }

  // select - vybraná položka
  if ($('.js-select-selected').length) {
    $('.js-select-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      width: 'resolve'
    });
  }

  // select - položka s vyhledáváním
  if ($('.js-select-search').length) {
    $('.js-select-search').select2({
      language: 'cs',
      dropdownCssClass: 'has-search',
      width: 'resolve'
    });
  }

  // select - vybraná položka s vyhledáváním
  if ($('.js-select-search-selected').length) {
    $('.js-select-search-selected').select2({
      language: 'cs',
      selectionCssClass: 'is-selected',
      dropdownCssClass: 'has-search',
      width: 'resolve'
    });
  }

  // select - řešení multiple selectu
  if ($('.js-select-multi').length) {
    $('.js-select-multi').on('change', function() {
      var selectActual = $(this).val();
      var selectConnect = '#' + $(this).data('multi');
      $(selectConnect + ' option[value="' + selectActual + '"]').prop(
        'selected',
        true
      );
      // nastavení stránkování na 1
      $('#strana').val(1);
      // odeslání formuláře
      $('#sbirky').submit();
    });
  }

  // select - datum se sliderem
  if ($('.js-date-slider').length) {
    $('.js-date-slider .select-false__input').on('click', function() {
      $(this)
        .next('.slider')
        .toggleClass('is-open');
    });
  }

  // select - odeslání formuláře sbírky po změně
  $('.js-submit-collection').on('change', function() {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // select - odeslání formuláře kolekce po změně
  $('.js-submit-collist').on('change', function() {
    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#collist').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.js-form-select').on('change', function() {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.js-form-input').on('change', function() {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - stránkování
  $('.js-form-page').on('change', function() {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = $(this).val();

    $(inputSelect).val(inputValue);

    // odeslání formuláře
    $('#sbirky').submit();
  });

  // formulář - hodnota do skrytého pole
  $('.js-form-checkbox').on('change', function() {
    var inputSelect = '#' + $(this).data('input');
    var inputValue = '0';

    if ($(this).prop('checked')) {
      inputValue = '1';
    }

    $(inputSelect).val(inputValue);

    // nastavení stránkování na 1
    $('#strana').val(1);
    // odeslání formuláře
    $('#sbirky').submit();
  });

  // vlastní slider
  if ($('#slider').length) {
    // hodnoty z data atributů
    var sliderMin = $('#slider').data('min');
    var sliderMax = $('#slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#slider').data('mins');
    var sliderMaxSelected = $('#slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    var slider = document.getElementById('slider');

    noUiSlider.create(slider, {
      start: [sliderMinSelected, sliderMaxSelected],
      connect: true,
      step: 1,
      range: {
        min: sliderMin,
        max: sliderMax
      }
    });

    var dateValues = [
      document.getElementById('slider-min'),
      document.getElementById('slider-max')
    ];

    // aktualizace hodnot v inputech
    slider.noUiSlider.on('update', function(values, handle) {
      dateValues[handle].value = Math.ceil(values[handle]);
    });

    // odeslání formuláře po tažení
    slider.noUiSlider.on('set', function(values, handle) {
      sliderChecker();
    });
  }

  // odeslání formuláře po ruční změně
  $('#slider-min').on('change', function() {
    sliderChecker();
  });
  $('#slider-max').on('change', function() {
    sliderChecker();
  });

  // řešení odeslání formuláře po změně hodnot slideru
  function sliderChecker() {
    // hodnoty z data atributů
    var sliderMin = $('#slider').data('min');
    var sliderMax = $('#slider').data('max');
    // aktuální pozice
    var sliderMinSelected = $('#slider').data('mins');
    var sliderMaxSelected = $('#slider').data('maxs');
    // ošetření min/max pozice
    if (!sliderMinSelected) {
      sliderMinSelected = sliderMin;
    }
    if (!sliderMaxSelected) {
      sliderMaxSelected = sliderMax;
    }

    // nastavení stránkování na 1
    $('#strana').val(1);

    // hodnoty do skrytých polí (pro porovnání)
    var sliderMinActual = dateValues[0].value;
    var sliderMaxActual = dateValues[1].value;
    if (sliderMinSelected != sliderMinActual) {
      $('#datfset').val(sliderMinActual);
    }
    if (sliderMaxSelected != sliderMaxActual) {
      $('#dattset').val(sliderMaxActual);
    }

    // odeslání formuláře
    $('#sbirky').submit();
  }
});

//# sourceMappingURL=scripts.js.map
